import React from 'react';
import { useTranslation } from 'react-i18next';

const Requzite = () => {
    const { t } = useTranslation();

    return (
        <div>
            <main className="requisites">
                <div className="requisites__container">
                    <section className="requisites__section">
                        <h2 className="requisites__section-title">{t('requisites.mainInfo')}</h2>
                        <ul className="requisites__list">
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.fullName')}</span>
                                <span className="requisites__value">Ассотсиатсияи бонкҳои Тоҷикистон</span>
                            </li>
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.shortName')}</span>
                                <span className="requisites__value">АБТ</span>
                            </li>
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.legalAddress')}</span>
                                <span className="requisites__value">{t('requisites.legalAddress2')}</span>
                            </li>
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.taxId')}</span>
                                <span className="requisites__value">020000000</span>
                            </li>
                        </ul>
                    </section>

                    <section className="requisites__section">
                        <h2 className="requisites__section-title">{t('requisites.bankDetails')}</h2>
                        <ul className="requisites__list">
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.account')}</span>
                                <span className="requisites__value">20202972900000000001</span>
                            </li>
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.bank')}</span>
                                <span className="requisites__value">КВД БА Амонатбонк</span>
                            </li>
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.bic')}</span>
                                <span className="requisites__value">350101000</span>
                            </li>
                            <li className="requisites__item">
                                <span className="requisites__label">{t('requisites.corrAccount')}</span>
                                <span className="requisites__value">30101810900000000001</span>
                            </li>
                        </ul>
                    </section>

                    <div className="download">
                        <a href="#" className="download__button">
                            <span className="download__icon">📥</span>
                            {t('requisites.downloadPdf')}
                        </a>
                    </div>
                </div>

                <div className="contact">
                    <h2 className="contact__title">{t('requisites.contactInfo')}</h2>
                    <ul className="contact__list">
                        <li className="contact__item">
                            <span className="contact__icon">📞</span>
                            +992 44 600 70 18
                        </li>
                        <li className="contact__item">
                            <span className="contact__icon">✉️</span>
                            abt_it@abt.tj 
                        </li>
                    </ul>
                </div>
            </main>
        </div>
    );
};

export default Requzite;
